import "./prototypes/element";
import "./prototypes/array";
import "./prototypes/nodelist";
